export const tr = {
    add: 'Ekle',
    edit: 'Düzenle',
    'upload-error': 'Dosya türü geçersizdir: JPEG veya PNG grafik formatlarını kullanın',
    'upload-source': 'Bilgisayardan yükle'
};
